import { request } from "../../apis";
import {
  checkOTPParamType,
  forgotPasswordParamType,
  sendOTPParamType,
  signinParamType,
  signupParamType,
} from "./data";

export const apiSignIn = (params: signinParamType) =>
  request("post", `/api/user/login`, params, true, true);

export const apiSignUp = (params: signupParamType) =>
  request("post", `/api/user/register`, params, true, true);

export const apiSendRegisterOTP = (params: sendOTPParamType) =>
  request("post", `/api/mail/send/user/register`, params, true);

export const apiSendOTP = (params: sendOTPParamType) =>
  request("post", `/api/mail/send/user/forgetpassword`, params, true);

export const apiCheckOTP = (params: checkOTPParamType) =>
  request("post", `/api/user/forget/password/checkotp`, params, true);

export const apiForgotPassword = (params: forgotPasswordParamType) =>
  request("put", `/api/user/forget/password`, params, true);

export const apiSignOut = () =>
  request("post", `/api/user/logout`, null, true, true);
